module.exports = __webpack_public_path__ + "static/media/social_life.d141f0b8.svg";